import { chakra, HStack, IconButton } from '@chakra-ui/react';
import Carousel from 'nuka-carousel';
import React from 'react';
import { LeftChevron, RightChevron } from '../../icons';
type RemarkCarouselProps = {
  frameAriaLabel: string;
  slides: JSX.Element[];
  leftButtonRef: React.MutableRefObject<HTMLButtonElement | null>;
  focusable: boolean;
  cellSpacing?: number;
  slidesToScroll?: number;
  slidesToShow?: number;
  hideBullets?: boolean;
  wrapAround: boolean;
  overflow?: string;
  slideWidth?: string;
  slideIndex?: number;
};
export const RemarkCarousel: React.FC<RemarkCarouselProps> = (props) => {
  const {
    frameAriaLabel,
    slides,
    leftButtonRef,
    focusable,
    cellSpacing,
    slidesToScroll,
    slidesToShow,
    hideBullets,
    wrapAround,
    slideWidth,
    overflow,
    slideIndex
  } = props;

  return (
    <Carousel
      autoplay={false}
      slideWidth={slideWidth}
      dragThreshold={0.3}
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      cellSpacing={cellSpacing}
      wrapAround={wrapAround}
      style={{ overflow: overflow || 'hidden' }}
      frameAriaLabel={frameAriaLabel}
      slideIndex={slideIndex}
      renderBottomCenterControls={
        hideBullets
          ? () => <></>
          : ({ currentSlide, slideCount, goToSlide }) => (
              <HStack
                borderRadius="full"
                bg="scheme.backgroundPrimary"
                padding="5px"
                align="center"
                spacing="4px"
                borderColor="scheme.borderPrimary"
                borderWidth="1px"
              >
                {[...Array(slideCount)].map((_, index) => (
                  <chakra.button
                    onClick={() => goToSlide(index)}
                    type="button"
                    aria-label={`slide ${index + 1} bullet`}
                    cursor="pointer"
                    backgroundColor={currentSlide === index ? 'scheme.whiteCompatible' : 'scheme.neutral3'}
                    height="6px"
                    width="6px"
                    borderRadius="full"
                    key={index}
                    tabIndex={-1}
                  />
                ))}
              </HStack>
            )
      }
      renderCenterLeftControls={({ previousSlide, previousDisabled }) =>
        !previousDisabled && (
          <IconButton
            onClick={previousSlide}
            aria-label="previous photo"
            w="20px"
            h="20px"
            minW="20px"
            border="0.5px solid"
            marginLeft="12px"
            zIndex="docked"
            borderColor="scheme.borderPrimary"
            borderRadius="8px"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.06)"
            background="scheme.backgroundPrimary"
            _hover={{
              background: 'scheme.backgroundPrimary',
              borderColor: 'scheme.borderSecondary',
              '& > svg': {
                fill: 'scheme.contentSecondary'
              }
            }}
            tabIndex={focusable ? 0 : -1}
            _active={{
              background: 'scheme.backgroundPrimary',
              boxShadow: 'none',
              '& > svg': {
                fill: 'scheme.contentPrimary'
              }
            }}
            ref={leftButtonRef}
            icon={<LeftChevron fill="scheme.contentTertiary" width="6px" />}
          />
        )
      }
      renderCenterRightControls={({ nextSlide, nextDisabled }) =>
        !nextDisabled && (
          <IconButton
            onClick={nextSlide}
            aria-label="next photo"
            w="20px"
            h="20px"
            minW="20px"
            maxH="20px"
            marginRight="12px"
            borderRadius="8px"
            background="scheme.backgroundPrimary"
            boxShadow="0px 2px 4px rgba(0, 0, 0, 0.06)"
            border="0.5px solid"
            zIndex="docked"
            borderColor="scheme.borderPrimary"
            _hover={{
              background: 'scheme.backgroundPrimary',
              borderColor: 'scheme.borderSecondary',
              '& > svg': {
                fill: 'scheme.contentSecondary'
              }
            }}
            tabIndex={focusable ? 0 : -1}
            _active={{
              background: 'scheme.backgroundPrimary',
              boxShadow: 'none',
              '& > svg': {
                fill: 'scheme.contentPrimary'
              }
            }}
            icon={<RightChevron fill="scheme.contentTertiary" width="6px" />}
          />
        )
      }
    >
      {slides}
    </Carousel>
  );
};
